import React, { useState, useContext } from 'react';
import { useForm } from 'react-hook-form';

import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import Modal from 'app/src/elements/Modal';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import AuthContext from '../../../contexts/AuthContext';
import Input from 'app/src/elements/inputs';
import { View, Text } from 'react-native';
import elRed from '../../../styles/colors';

export const Counter = ({
  feeEstimate, setShowModal, updateFeeEstimate
}) => {
  const { user } = useContext(AuthContext);
  const [acceptMethod, setAcceptMethod] = useState('');
  const [notes, setNotes] = useState('');
  const [required, setRequired] = useState(false);

  const saveAccept = () => {
    if(acceptMethod && acceptMethod !== 'Select') {
      updateFeeEstimate({
        variables: {
          id: feeEstimate.id,
          status: 'Accepted',
          acceptedByType: 'User',
          acceptedById: user?.id,
          acceptMethod: acceptMethod,
          notes: notes
        }
      });
    }else {
      setRequired(true)
    }
  };

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType={feeEstimate.asset.stockNumber}
      objectName={feeEstimate.asset.name}
    >
      <View style={{display: 'flex', flexDirection: 'row'}}>
        <FieldLabel label="Accept Fee Estimate?" />
        {required &&
          <Text style={{color: elRed, fontWeight: 'bold'}}> Required</Text>
        }
      </View>
      {feeEstimate.activeFor === 'SellerUser' &&
        <View>
          <select
            onChange={(e) => {
              setAcceptMethod(e.target.value);
              if(e.target.value !== 'Select') {
                setRequired(false);
              }
            }}
          >
              <option value={null}>Select</option>
              {['Email','Call'].map(option => {
                return <option value={option}>{option}</option>
              })}
          </select>
          <br />
          <FieldLabel label="Notes:" />
          <input
            type='text'
            onChange={(e) => setNotes(e.target.value)}
          />
        </View>
      }
      <ButtonGroup>
        <Button label="Update" onPress={saveAccept} />
      </ButtonGroup>
    </Modal>
  );
};

export default Counter;
